// TODO: Remove from `core-js@4`
require('../modules/es.global-this');



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/modules/esnext.global-this.js